module.exports = __webpack_public_path__ + "static/media/sold-out.ed0cbabb.png";